define([
    "jquery",
    "underscore",
    "marionette",
    "models/callback_request_model",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, CallbackRequestModel, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#call_popup',

        ui:{
            'submitBtn': '.ct_btn8',
            'form': '#callback_form',
            'captchaImage': '#captcha_image'
        },

        events:{
            'click @ui.submitBtn': 'submit'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();

            this.model = new CallbackRequestModel();
        },

        submit: function(e){
            var that = this;
            if(e) e.preventDefault();

            var formData = Backbone.Syphon.serialize(this);
            this.model.set(formData);

            if(this.captchaCheck){
                this.model.set('captcha_check', this.captchaCheck);
            }

            var errors = this.model.validate();

            if(!formData['captcha_code']){
                errors = _.extend({}, errors, {captcha_code: 'You must complete the captcha.'});
            }

            if(_.size(errors) < 1){
                this.model.set('phone_number', this.model.get('phone_country')+'-'+this.model.get('phone_area')+'-'+this.model.get('phone_rest'));
                HoldOn.open({
                    theme:"sk-fading-circle"
                });
                this.model.save(null, {
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form[0].reset();
                        that.ui.captchaImage.attr('src', '/common/show_captcha');
                        that.triggerMethod('show:success');
                    },
                    error: function(model, error){
                        if(error.responseJSON.captcha_check){
                            that.captchaCheck = error.responseJSON.captcha_check;
                        }
                        delete error.responseJSON.captcha_check;
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                }).always(function(){
                    HoldOn.close();
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/common/callback_view.js
// module id = 15
// module chunks = 0